module.exports = __webpack_public_path__ + "img/img-error.6448652a.png";